import {
  OverseasAssetSchema,
  OverseasAsset_InitialState,
  RadioSelect,
  RangeSlider,
  Select,
  TextArea,
  TextInput,
  countriesList,
  useOptions
} from "@fla/components";
import OverseasIcon from "@fla/components/src/assets/svgs/overseas.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: OverseasAsset_InitialState;
  onSubmit: (values: OverseasAsset_InitialState) => void;
}
const Details: FC<IProps> = ({ formId, store, onSubmit }) => {
  const { initialDetails } = useSelector(selectConsentOrdersBase);

  const { assetTypeOptions, ownerV2Options, saleProceedsOptions, splitByOptions } = useOptions({ initialDetails });

  const { handleSubmit, control, watch, setValue } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(OverseasAssetSchema)
  });

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <div className="my-8 flex flex-col items-center justify-center">
        <img src={OverseasIcon} className="w-10 h-auto my-3" alt="bank" />
        <h3 className="font-bold">Overseas Asset</h3>
      </div>
      <TextInput
        title="Describe the Asset"
        control={control}
        name="name"
        id="name"
        placeholder="Eg: UK Pension with Railways Pension Scheme"
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <Select
        title="What country is it in?"
        control={control}
        name="country"
        id="country"
        placeholder="Select"
        options={countriesList.map(country => ({
          label: country.name,
          value: country.code
        }))}
      />
      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <Select
        title="What type of asset is this"
        control={control}
        name="asset_type"
        id="asset_type"
        placeholder="Select"
        options={assetTypeOptions}
      />
      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <Select
        title="In whose name is this in?"
        control={control}
        name="owner"
        id="owner"
        placeholder="Select"
        options={ownerV2Options}
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <TextInput title="Approx Value" control={control} name="value" id="value" placeholder="" isAmount />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <RadioSelect
        title="What happens to this"
        type="card-brief"
        name="split_by"
        id="split_by"
        control={control}
        options={splitByOptions as []}
        classes="my-8"
        onChange={v => {
          if (v === "percentage") {
            setValue("percentage", { user: "50", spouse: "50" });
          }
        }}
      />

      {watch("split_by") === "sell" ? (
        <RadioSelect
          title="How will the net sale proceeds be divided"
          type="card-brief"
          name="sale_proceeds"
          id="sale_proceeds"
          control={control}
          options={saleProceedsOptions as []}
          classes="my-8"
          onChange={v => {
            if (v === "percentage") {
              setValue("percentage", { user: "50", spouse: "50" });
            }
          }}
        />
      ) : null}

      {[watch("split_by"), watch("sale_proceeds")].includes("percentage") ? (
        <RangeSlider
          title="Split By A Percentage"
          control={control}
          name="percentage.user"
          id="percentage.user"
          exName={initialDetails?.spouse?.first_name || "N/A"}
          percentageOf={watch("value")}
          onChange={val => {
            setValue("percentage.spouse", `${100 - Number(val)}`);
          }}
        />
      ) : null}

      <TextArea
        title="Further comments you want us to know about this (optional)"
        control={control}
        name="comment"
        id="comment"
        placeholder="Description"
      />
    </form>
  );
};

export default Details;
